import React from "react";
import { MetricLabel } from "../../MetricCards";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import {
  formatMoney,
  formatNumber,
  formatPercent
} from "../../utils/formatters";

export function AnalyticsRetentionBlock({ analyticsData, retention }) {
  return (
    <div className={analyticsStyles.block}>
      <h3>Удержание и ценность</h3>
      <div className={panelStyles.tableWrap}>
        <table className={panelStyles.table}>
          <tbody>
            <tr>
              <td>
                <MetricLabel
                  title="Удержание D1 / D7 / D30"
                  hint="Доля пользователей, активных на день 1/7/30 после регистрации."
                />
              </td>
              <td>{formatPercent(retention.d1)} / {formatPercent(retention.d7)} / {formatPercent(retention.d30)}</td>
            </tr>
            <tr>
              <td>
                <MetricLabel title="Повторные покупки" hint="Пользователи с 2+ покупками; доля от всех платящих." />
              </td>
              <td>{formatNumber(analyticsData.money.repeatPurchaseCount)} ({formatPercent(analyticsData.money.repeatPurchaseRate)})</td>
            </tr>
            <tr>
              <td>
                <MetricLabel title="% продления после 1 месяца" hint="Доля платящих с разницей между первой и последней покупкой 30+ дней." />
              </td>
              <td>{formatPercent(analyticsData.money.renewRate)}</td>
            </tr>
            <tr>
              <td>
                <MetricLabel
                  title="LTV (платные)"
                  hint="Lifetime LTV: сумма всех оплат (amount>0) / уникальные платящие пользователи (amount>0)."
                />
              </td>
              <td>{formatMoney(analyticsData.money.ltv)}</td>
            </tr>
            <tr>
              <td>
                <MetricLabel title="CAC" hint="Маркетинг за месяц / новые платящие за месяц." />
              </td>
              <td>{formatMoney(analyticsData.money.cac)}</td>
            </tr>
            <tr>
              <td>
                <MetricLabel title="LTV / CAC" hint="Отношение LTV к CAC." />
              </td>
              <td>{formatNumber(analyticsData.money.ltvToCac)}</td>
            </tr>
            <tr>
              <td>
                <MetricLabel title="Средний цикл жизни (дней)" hint="Среднее дней между первой и последней покупкой." />
              </td>
              <td>{formatNumber(analyticsData.money.lifecycleDays)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AnalyticsRetentionBlock;
